import { addPermissionsToRoute } from '@qsrsoft/myq-core';
import { multiClientMenuFilters } from '../mtEnterprises';
const routes = {
  name: 'Service',
  icon: 'mdi-hand-heart-outline',
  path: '/reports/service',
  ...addPermissionsToRoute(['mtService']),
  menuFilters: multiClientMenuFilters,
  children: [
    {
      path: '/reports/service/serviceTimesStatistics',
      name: 'Service Times Statistics',
      meta: { id: 'reports-mtServiceTimesStatistics' },
      component: () => import('./SpeedOfService.vue'),
    },
    {
      path: '/reports/service/serviceTimes',
      name: 'Service Times (Legacy)',
      meta: { id: 'reports-mtServiceTimes' },
      component: () => import('./ServiceTimeStatistics.vue'),
    },
  ],
};

export default routes;
